import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center flex-1 flex flex-col mx-4 lg:mx-0" }
const _hoisted_2 = {
  key: 0,
  class: "flex-shrink flex mx-auto my-4 lg:my-8 lg:justify-center justify-end space-x-4 w-full",
  "data-aos": "fade-left"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "my-auto" }, "words left", -1)
const _hoisted_4 = { class: "flex bg-palette2 text-white rounded-full w-8 h-8" }
const _hoisted_5 = { class: "m-auto text-xs" }
const _hoisted_6 = {
  key: 1,
  class: "lg:flex-none flex-1 flex flex-col"
}
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl pt-20" }, "no cards left to review", -1)
const _hoisted_11 = [
  _hoisted_10
]

import randomItem from "random-item";
import { isDue, practice } from "./../practice";

import { deleteCard, updateCard } from "../server";
import PracticeFront from "../components/PracticeFront.vue";
import PracticeBack from "../components/PracticeBack.vue";
import EditCard from "../components/EditCard.vue";
import { CardData } from "@/CardData";
import { computed, onMounted, Ref, ref } from "vue";
import { gtag } from "@/gtag";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const card: Ref<CardData | null> = ref(null);
const showBack = ref(false);
const editing = ref(false);

onMounted(() => {
  gtag.event("page:practice");
  loadNewCard();
});

function loadNewCard() {
  if (hasCardsLeft.value) {
    showBack.value = false;
    console.log("cards left: " + JSON.stringify(cardsLeft.value));
    if (!cardsLeft.value) throw new Error("no cards left");
    card.value = randomItem(cardsLeft.value);
    console.log("card:" + card.value);
  }
}
function easy() {
  answer(5);
}
function hard() {
  answer(3);
}
function veryHard() {
  loadNewCard();
  //this.answer(1);
}
function remove() {
  store.commit("removeCard", card.value);
  if (!sessionId.value) throw new Error("sessionId is null");
  deleteCard(card.value, sessionId.value);
  loadNewCard();
}
function answer(grade: number): void {
  let afterPractice = practice(card.value, grade);
  store.commit("updateCard", afterPractice);

  if (!sessionId.value) throw new Error("sessionId is null");

  updateCard(afterPractice, sessionId.value);

  gtag.event("practice-once");
  loadNewCard();
}

const sessionId = computed(() => store.state?.sessionId);

const cards = computed(() => store.state.user?.cards);
const cardsLeft = computed(() => cards.value?.filter((x) => isDue(x)));

const cardsLeftCount = computed(() => cardsLeft.value?.length);
const hasCardsLeft = computed(() => cardsLeftCount.value ?? 0 > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasCardsLeft))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(cardsLeftCount)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(hasCardsLeft))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (card.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!showBack.value)
                  ? (_openBlock(), _createBlock(PracticeFront, {
                      key: 0,
                      class: "lg:w-1/3 lg:mx-auto mt-0 lg:mt-0",
                      card: card.value,
                      onFlip: _cache[0] || (_cache[0] = ($event: any) => (showBack.value = true)),
                      "data-aos": "fade-in"
                    }, null, 8, ["card"]))
                  : _createCommentVNode("", true),
                (showBack.value)
                  ? (_openBlock(), _createBlock(PracticeBack, {
                      key: 1,
                      class: "lg:w-1/2 lg:mx-auto",
                      card: card.value,
                      onEasy: _cache[1] || (_cache[1] = ($event: any) => (easy())),
                      onNormal: _cache[2] || (_cache[2] = ($event: any) => (hard())),
                      onHard: _cache[3] || (_cache[3] = ($event: any) => (veryHard())),
                      onDelete: _cache[4] || (_cache[4] = ($event: any) => (remove())),
                      onEdit: _cache[5] || (_cache[5] = ($event: any) => (editing.value = !editing.value)),
                      "data-aos": "fade-in"
                    }, null, 8, ["card"]))
                  : _createCommentVNode("", true),
                (editing.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(EditCard, {
                        card: card.value,
                        class: "mx-4 my-8",
                        onFinished: _cache[6] || (_cache[6] = ($event: any) => (editing.value = false))
                      }, null, 8, ["card"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}
}

})